import AutorenewTwoToneIcon from '@mui/icons-material/AutorenewTwoTone';
import { Button, Collapse, IconButton, SvgIcon, TableCell, TableRow } from '@mui/material';
import { Box } from '@mui/system';
import clsx from 'clsx';
import { map } from 'lodash';
import React, { ComponentType, ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icons } from 'src/components/icons';
import { useRouter } from 'src/hooks';
import { ApiUser } from 'src/http/api-user';
import useStyles from './styles';

interface DataTableRowProps {
  item: Record<string, any>;
  columns: Record<string, any>[];
  expandable?: boolean;
  renderExpanded?: (item: Record<string, any>) => ReactNode;
  expandCallback?: (item: Record<string, any>) => void;
}
export const DataTableRow: ComponentType<DataTableRowProps> = ({
  item,
  columns,
  expandable,
  renderExpanded,
  expandCallback,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const router = useRouter();

  const handleExpandRow = () => {
    !expanded && expandCallback && expandCallback(item);
    setExpanded(!expanded);
  };

  const updateProfile = async (id: string | number) => {
    try {
      await ApiUser.updateProfile(id);
      window.location.reload();
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  return (
    <React.Fragment>
      <TableRow
        className={clsx(classes.row, {
          [classes.expandableRow]: expandable,
          [classes.expandedRow]: expandable && expanded,
        })}
      >
        {map(columns, (col, index) => (
          <TableCell className={classes.cell} width={col.width} key={index}>
            <Box className={classes.cellWrap}>{col.renderItem(item)}</Box>
            {console.log(item)}
          </TableCell>
        ))}
        {router.pathname === '/cabinet/users' && (
          <Button onClick={() => updateProfile(item?.id)}>
            {t('action.updateData')} &nbsp; <AutorenewTwoToneIcon />
          </Button>
        )}
        {expandable && (
          <TableCell className={clsx(classes.cell, classes.expandButtonWrap)}>
            <IconButton
              aria-label={t('expandContent', 'Показать контент')}
              size="large"
              onClick={handleExpandRow}
              className={clsx(classes.expandButton, { [classes.expandButtonExpanded]: expanded })}
            >
              <SvgIcon component={Icons.Dropdown} viewBox="0 0 16 16" />
            </IconButton>
          </TableCell>
        )}
      </TableRow>
      {expandable && renderExpanded && (
        <TableRow className={classes.row}>
          <TableCell className={classes.cell} colSpan={columns.length + 1}>
            <Collapse in={expanded} sx={{ mb: 0.5 }}>
              {renderExpanded(item)}
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </React.Fragment>
  );
};
